import { render, staticRenderFns } from "./main.vue?vue&type=template&id=60c3acd9"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c3acd9')) {
      api.createRecord('60c3acd9', component.options)
    } else {
      api.reload('60c3acd9', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=60c3acd9", function () {
      api.rerender('60c3acd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/basic/message/src/main.vue"
export default component.exports